module.exports = __webpack_public_path__ + "assets/c4f92721.wav";